<template>
    <div class="my-scroll" :class="[scrollState?'prohibit':'allow']" ref="myScroll" @scroll.passive="onScroll($event)"
         @touchstart="touchStart($event)" @touchmove="touchMove($event)" @touchend="touchEnd($event)">
        <div class="scroll-list" :style="{ transform: 'translate3d(0, ' + top + 'px, 0)'}">
            <slot name='scrollList'></slot>
            <div v-if="aspect==1">
                <div class="expired_more" v-if="aspect==1">
                    <div class="load_more" v-if="state==4">
                        <img class="loadLogo" src="../assets/image/return/Group 53.png">
                        <span>{{$t('common.loadMore')}}</span>
                    </div>
                    <div class="load_more" v-if="state==5">
                        <span>{{$t('common.finishLoading')}}</span>
                    </div>
                    <div class="load_more" v-if="state==7">
                        <span>{{$t('common.noMore')}}</span>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script type="text/javascript">
import tween from '../assets/js/tween.js'
import Load from '../assets/image/common/flush.jpg'

export default {
  name: 'myScroll',
  props: {
    'page': {
      type: Object // counter:当前页  pageStart:开始页数  pageEnd:结束页数  total:总页数
    },
    'onRefresh': { // 刷新回调
      type: Function,
      require: true
    },
    'onPull': { // 加载回调
      type: Function,
      require: true
    },
    'scrollState': {// 是否可滑动
      type: Boolean,
      require: true
    }
  },
  data () {
    return {
      Load,
      pageX: 0, // 触摸点x轴
      pageY: 0, // 触摸点y轴
      state: 0, // 当前状态
      scrollPosition: 0, // 滚动条位置
      myScroll: null,
      myScrollList: null,
      top: 0, // 列表位置
      aspect: 0, // 1:向下 2:向上
      listHeight: 0,
      screenHeight: 0
    }
  },
  methods: {
    ScrollTop (top) { // 修改滚动条位置
      this.myScroll.scrollTop = top
    },
    /*
         * 刷新中：1
         * 松开刷新：2
         * 刷新完成：3
         * 加载中：4
         * 加载完成：5
         * 下拉刷新：6
         * 没有更多：7
     */
    setState (index) { // 修改状态
      this.state = index
      if (index == 5 || index == 3 || index == 7) {
        setTimeout(() => {
          this.state = 0
          let timer = null
          let that = this
          let b = 50, c = 100, d = 100, t = 0
          cancelAnimationFrame(timer)
          timer = requestAnimationFrame(function fn () {
            let oTop = that.top
            if (that.top > 0) {
              that.top = Math.ceil(tween.Quart.easeInOut(10, oTop, 8, 10)) - 15
              timer = requestAnimationFrame(fn)
            } else {
              cancelAnimationFrame(timer)
              that.top = 0
            }
          })
        }, 500)
      }
    },
    touchStart (e) { // 触摸事件
      // 点击的x轴
      this.pageX = e.targetTouches[0].pageX
      // 点击的y轴
      this.pageY = e.targetTouches[0].pageY
    },
    touchMove (e) { // 触摸滑动事件
      let bestBottom = this.isBottom()
      if (bestBottom) {
        this.scrollPosition = this.myScroll.scrollTop // 获取滚动条位置
        if (this.scrollState && e.targetTouches[0].pageY < this.pageY) { // 上拉
          this.aspect = 1
          // 位移了多少
          let diff = e.targetTouches[0].pageY - this.pageY - this.scrollPosition
          this.top = diff
          this.state = 4
          e.preventDefault()
        }
      }
    },
    touchEnd (e) {
      // this.screenHeight = window.innerHeight
      if (this.aspect == 1 && this.state == 4) {
        this.top = -100
        this.bottomCallback()
      } else {
        this.state = 0
        this.top = 0
      }
    },
    onScroll (e) {
      let listHeight = this.myScrollList.offsetHeight // 列表总高度
      let listScrollTop = e.target.scrollTop + this.myScroll.offsetHeight // 当前滚动条位置
      if (this.state == 0 && listHeight - listScrollTop < 100) {
        this.bottomCallback()
      }
      if (this.getScrollTop) this.getScrollTop(e.target.scrollTop) // 返回X，Y
    },
    bottomCallback () { // 上拉加载回调
      this.onPull()
    },
    isBottom () {
      let offset = 0
      if (window.innerHeight !== this.screenHeight) {
        offset = window.innerHeight - this.screenHeight
        // alert(offset)
      }
      if ((offset + document.documentElement.clientHeight + document.documentElement.scrollTop) >= document.documentElement.offsetHeight) {
        return true
      } else {
        return false
      }
    }
  },
  mounted () {
    this.myScroll = this.$refs.myScroll // 获取滑条dom
    this.myScrollList = this.myScroll.children[0] // 获取列表dom
    this.screenHeight = window.innerHeight
  }
}
</script>
<style lang="less" scoped>
    .allow {
        overflow: hidden;
        height: auto;
    }

    .prohibit {
        max-width: 100%;
        max-height: 100%;
        height: 100%;
        overflow-y: scroll;
        -webkit-overflow-scrolling: touch;
        will-change: transform;
        transition: all 450ms;
        backface-visibility: hidden;
        perspective: 1000;
    }

    .my-scroll {
        position: relative;
        color: #fff;

        .scroll-top {
            text-align: center;
            display: flex;
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            overflow: hidden;

            div {
                display: flex;
                height: auto;
                width: 100%;
                justify-content: center;
                align-items: center;
                flex-wrap: wrap;

                i {
                    flex: 1 0 100%;
                    display: block;
                    height: 0.4rem;
                }

                img {
                    width: 0.6rem;
                }

                p {
                    flex: 1 0 100%;
                }
            }
        }

        .scroll-list {
            min-height: 100%;
        }

        .scroll-bottom {
            text-align: center;
            line-height: 40px;
        }
    }

    .expired_more {
        width: 100%;
        position: relative;

        .load_more {
            position: absolute;
            left: 50%;
            transform: translateX(-50%);
            margin-top: 0.11rem;
            display: flex;
            justify-content: center;
            align-items: center;

            img {
                width: 0.215rem;
                height: 0.215rem;
            }

            span {
                color: #ACACAC;
                font-size: 0.15rem;
                font-family: Rubik;
                font-weight: 900;
                line-height: 0.18rem;
                margin-top: 0.045rem;
                margin-left: 0.07rem;
            }
        }
    }

    .loadLogo {
        animation: turn 600ms linear infinite;
    }

    @keyframes turn {
        0% {
            -webkit-transform: rotate(0deg);
        }
        25% {
            -webkit-transform: rotate(90deg);
        }
        50% {
            -webkit-transform: rotate(180deg);
        }
        75% {
            -webkit-transform: rotate(270deg);
        }
        100% {
            -webkit-transform: rotate(360deg);
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/MyScroll.vue